export const STUDIO = {
  name: "Obsidian Art & Tattoo Studio",
  shortName: "Obsidian Ink",
  tagline: "Where precision meets prestige.",
  address: "6801 Backlick Rd Suite C",
  cityStateZip: "Springfield, VA 22150",
  phone: "(571) 378-1993",
  phoneHref: "tel:+15713781993",
  email: "bookobsidianink@gmail.com",
  instagram: "https://www.instagram.com/obsidianinkstudio/",
  yelp: "https://www.yelp.com/biz/obsidian-ink-studio-springfield-2",
  maps: "https://www.google.com/maps/place/Obsidian+Art+%26+Tattoo+Studio",
  logo: "https://irp.cdn-website.com/2f9ed54f/dms3rep/multi/opt/Untitled_Artwork-2675f1c4-1920w-1920w.webp",
};

export const HOURS = [
  { day: "Every day", time: "12:00 PM — 7:00 PM" },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Artists", to: "/artists" },
  { label: "About", to: "/about" },
  { label: "Portfolio", to: "/portfolio" },
];

export const PROJECT_TYPES = [
  "Small Tattoo", "Large Tattoo", "Sleeve", "Back Piece", "Chest",
  "Leg", "Cover-Up", "Portrait", "Custom Concept",
];

export const SIZES = ["Under 3 in", "3 – 6 in", "6 – 10 in", "Half sleeve / large", "Full sleeve / back"];

export const PLACEMENTS = [
  "Forearm", "Upper arm", "Full sleeve", "Hand", "Chest", "Back",
  "Ribs", "Thigh", "Calf", "Ankle", "Neck", "Other",
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1603566431089-7f077f615682?crop=entropy&cs=srgb&fm=jpg&q=85&w=2200";
export const STUDIO_IMAGE = "https://customer-assets-7cd3h4nn.emergentagent.net/job_ink-editorial/artifacts/roe259a2_Screenshot%202026-09-12%20at%209.55.51%E2%80%AFAM.webp";
export const PROCESS_IMAGE = "https://customer-assets-7cd3h4nn.emergentagent.net/job_ink-editorial/artifacts/qkjk2x83_Screenshot%202026-09-12%20at%2010.49.03%E2%80%AFAM.webp";

export const SHOP_IMAGES = [
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_ink-editorial/artifacts/rlamgc1b_IMG_9467.webp",
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_ink-editorial/artifacts/evcc30ig_IMG_9470.webp",
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_ink-editorial/artifacts/sk6gx1hg_IMG_8DE0F482C43D-1-b67bc9e3.jpeg",
];
